import {
    Component,
    ContentChildren,
    Input,
    OnDestroy,
    OnInit,
    QueryList
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ValidationMessageComponent } from 'angular/custom/components/validation-message.component';

@Component({
    selector: 'pkp-validation-messages',
    template:
        '<pkp-validation-message [show]="showGeneralMessage">{{generalMessage}}</pkp-validation-message><ng-content></ng-content>'
})
/**
 * See https://stackoverflow.com/a/42182602
 */
export class ValidationMessagesComponent implements OnInit, OnDestroy {
    @Input() for: FormControl;
    @Input() generalMessages: ValidationMessage[] = [];
    @ContentChildren(ValidationMessageComponent)
    messageComponents: QueryList<ValidationMessageComponent>;

    private statusChangesSubscription: Subscription;
    showGeneralMessage: boolean;
    generalMessage: string;

    ngOnInit() {
        this.statusChangesSubscription = this.for.statusChanges.subscribe(
            (x) => {
                this.showGeneralMessage = false;
                this.messageComponents.forEach(
                    (messageComponent) => (messageComponent.show = false)
                );
                if (this.for.invalid) {
                    // find in messageComponents
                    let firstErrorMessageComponent =
                        this.messageComponents.find((messageComponent) => {
                            return messageComponent.showsErrorIncludedIn(
                                Object.keys(this.for.errors)
                            );
                        });

                    if (firstErrorMessageComponent) {
                        firstErrorMessageComponent.show = true;
                        return;
                    }

                    // find in general messages
                    let generalMessage = this.generalMessages.find(
                        (message) => {
                            return Object.keys(this.for.errors).some(
                                (error) => error === message.name
                            );
                        }
                    );

                    if (generalMessage) {
                        this.showGeneralMessage = true;
                        this.generalMessage = generalMessage.value;
                    }
                }
            }
        );
    }

    ngOnDestroy() {
        this.statusChangesSubscription.unsubscribe();
    }
}

export interface ValidationMessage {
    name: string;
    value: string;
}
